import type { ReactNode } from 'react';
import { Tag } from '@eye-able/ui';
import { useBadgeVisibility } from '@layout/Sidebar/MenuList/useBadgeVisibility';
import type { MenuItem } from '@layout/Sidebar/MenuList/types';
import { T } from '@/i18n/T';

type NavItemLabelProps = {
  item: MenuItem;
  title?: ReactNode;
};

function NavItemLabel({ item, title }: NavItemLabelProps) {
  const Icon = item.handle?.icon;
  const badge = item.handle?.badge;

  const showBadge = useBadgeVisibility(badge);

  return (
    <div className='eye:flex eye:items-center eye:text-left'>
      {Icon ? (
        <div className='eye:mr-4xs' aria-hidden={true}>
          <Icon className='eye:w-24 eye:h-24' strokeWidth={1.6} />
        </div>
      ) : null}
      {title}
      {showBadge ? (
        <Tag className='eye:ml-4xs eye:capitalize eye:justify-center'>
          <T k={`${badge?.text || ''}`} />
        </Tag>
      ) : null}
    </div>
  );
}

export default NavItemLabel;
